import Logo from "../../assets/logo-full.png";
import Success from "../../assets/success.svg";
import Failed from "../../assets/failed.svg";
import { useCallback, useEffect, useState } from "react";
import api from "../../service/api";
import { useParams } from "react-router-dom";

export default function ScannQRCode() {
  const [checkin, setCheckin] = useState<string | boolean>(false);
  const [statusCode, setStatusCode] = useState(false);
  const [load, setLoad] = useState(true);
  const [latitude, setLatitude] = useState<number | null>(null);
  const [longitude, setLongitude] = useState<number | null>(null);
  const [locationError, setLocationError] = useState<string | null>(null);
  const { participant_id, event_id } = useParams();

  // Função para capturar a geolocalização
  const getCurrentLocation = useCallback(() => {
    if (!navigator.geolocation) {
      setLocationError("Geolocalização não é suportada por este navegador.");
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        setLatitude(position.coords.latitude);
        setLongitude(position.coords.longitude);
        setLocationError(null);
      },
      (error) => {
        let errorMessage = "Erro ao obter localização.";
        switch (error.code) {
          case error.PERMISSION_DENIED:
            errorMessage = "Permissão de localização negada pelo usuário.";
            break;
          case error.POSITION_UNAVAILABLE:
            errorMessage = "Informações de localização não disponíveis.";
            break;
          case error.TIMEOUT:
            errorMessage = "Tempo limite para obter localização excedido.";
            break;
        }
        setLocationError(errorMessage);
        console.warn("Erro de geolocalização:", errorMessage);
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 60000,
      }
    );
  }, []);

  const getCheckin = useCallback(async () => {
    // Verificar se temos localização antes de fazer o check-in
    // if (latitude === null || longitude === null) {
    //   setCheckin("Erro ao obter localização. Por favor, permita o acesso à localização e tente novamente.");
    //   setLoad(false);
    //   return;
    // }

    try {
      const res = await api.post("events/accreditation/checkin", {
        participant_id,
        event_id,
        lat: latitude,
        lng: longitude,
      });

      if (res.status === 201 || res.status === 200) {
        setStatusCode(true);
      }
      setCheckin(res.data.message);
    } catch (error: unknown) {
      const errorMessage = error instanceof Error && 'response' in error
        ? (error as { response?: { data?: { message?: string; error?: string } } }).response?.data?.message
        || (error as { response?: { data?: { message?: string; error?: string } } }).response?.data?.error
        || "Erro desconhecido"
        : "Erro desconhecido";
      console.log(errorMessage);
      setCheckin(errorMessage);
    } finally {
      setLoad(false);
    }
  }, [participant_id, event_id, latitude, longitude]);

  // Captura a localização quando o componente é montado
  useEffect(() => {
    getCurrentLocation();
  }, [getCurrentLocation]);

  // Executa o checkin quando tiver os parâmetros e a localização
  useEffect(() => {
    if (!participant_id || !event_id) return;

    // Aguarda um pouco para tentar capturar a localização antes de fazer o checkin
    const timer = setTimeout(() => {
      getCheckin();
    }, 4000);

    return () => clearTimeout(timer);
  }, [participant_id, event_id, getCheckin]);

  return (
    <main className="flex flex-col gap-20 justify-center items-center h-screen text-white text-3xl font-medium bg-[#0A3836]">
      <div className="w-[200px] text-center">
        <img
          src={Logo}
          alt="Logomarca"
          className={` ${load ? "animate-pulseLoading" : ""} mb-4`}
        />
        {load && (
          <div className="text-center">
            <span
              className={`text-lg text-[#f2f2f2] ${load ? "animate-pulseLoading" : ""
                }`}
            >
              Carregando...
            </span>
            {locationError && (
              <p className="text-sm text-red-300 mt-2">
                {locationError}
              </p>
            )}
          </div>
        )}
      </div>

      {!load && (
        <div className="flex flex-col items-center text-center">
          {statusCode ? (
            <div className="">
              <img src={Success} alt="Sucesso" />
            </div>
          ) : (
            <div className="">
              <img src={Failed} alt="Falhou" />
            </div>
          )}

          <h1 className="text-6xl font-bold mt-4 text-[#f2f2f2]">
            {statusCode ? "Sucesso" : "Falhou"}
          </h1>
          <p className="text-3xl mt-4 max-w-[350px] font-normal text-[#bebebe]">
            {checkin}
          </p>
        </div>
      )}
    </main>
  );
}
